import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Entries/ExecutionEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/FinancialReviewEntry'
import MaintenanceWorkflowForwardingFiscalAssessmentEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/FiscalAssessmentEntry'
import MaintenanceWorkflowForwardingActions from '../../../Sections/ForwardingActions'

const OnGoingFiscalAssessment = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingActions />

      <MaintenanceWorkflowForwardingFiscalAssessmentEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry showCompleted />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  )
}

export default OnGoingFiscalAssessment
